import { FC, Children, isValidElement, Fragment, PropsWithChildren } from 'react';
import { css } from '@emotion/react';
import { Divider } from '@frontend/divider';
import { breakpoints } from '@frontend/responsiveness';
import { theme } from '@frontend/theme';

export const FilterTrayContainer: FC<PropsWithChildren<{ show: boolean }>> = ({ children, show }) => {
  const childrenArray = Children.toArray(children).filter(isValidElement);

  if (!show) {
    return null;
  }

  return (
    <div css={styles.container}>
      {childrenArray.map((child, index) => (
        <Fragment key={index}>
          {child}
          {index < childrenArray.length - 1 && <Divider css={styles.divider} />}
        </Fragment>
      ))}
    </div>
  );
};

const styles = {
  container: css`
    display: flex;
    flex-direction: column;
    overflow: auto;
    height: 100%;
  `,

  divider: css`
    margin: ${theme.spacing(1, 0)};
    @media (max-width: ${breakpoints.xsmall.max}px) {
      display: none;
    }
  `,
};
